// TODO: pedir al back un id numérico único por registro para reemplazar el DNI.

import React from "react";
import { monitorMiaKey as baseTitles } from "consts/titulos-de-tablas";
import { EstadoCell, HorariosCell, EventosCell } from "../components/CustomCells";
import { Tooltip } from "@mui/material";

const truncatedCell = ({ value }) => (
    <Tooltip title={value ?? ""}>
        <span style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "block",
            width: "100%",
        }}>
            {value}
        </span>
    </Tooltip>
);


export const tableTitles = baseTitles.map((t) => {
    if (t.field === "Estado") {
        return { ...t, renderCell: ({ value }) => <EstadoCell value={value} /> };
    }
    if (t.field === "Horarios") {
        return { ...t, renderCell: ({ value }) => <HorariosCell value={value} /> };
    }
    if (t.field === "Eventos") {
        return { ...t, renderCell: ({ value }) => <EventosCell eventos={value} /> };
    }
    if (t.field === "NombreCompleto" || t.field === "Acceso") {
        return { ...t, renderCell: truncatedCell };
    }
    return t;
});

export function formatDNI(dni) {
    if (!dni) return "";
    return String(dni).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function esFormatoNuevo(item) {
    return "usuarioApellidos" in item || "tipoDeDocumentoCod" in item;
}

function mapEventosNuevo(eventos) {
    if (!Array.isArray(eventos)) return [];
    return eventos
        .map(e => {
            const hora = e.gateESHistoFH?.slice(11, 16) ?? "";
            const letra = e.gateESHistoStatusCode ?? "";
            return `${hora} ${e.gateESHistoMetodo} ${letra}`.trim();
        })
        .filter(Boolean);
}

export function mapRegistroToRow(item, index) {
    const esNuevo = esFormatoNuevo(item);

    const NombreCompleto = item.apellidoYNombre
        ?? (item.usuarioApellidos && item.usuarioNombres
            ? `${item.usuarioApellidos}, ${item.usuarioNombres}`
            : "");

    const DocumentoTipo = item.tipoDeDoc ?? item.tipoDeDocumentoCod ?? "";
    const DocumentoNumero = formatDNI(item.numeroDeDoc ?? item.usuarioNroDeDocumentoX);

    const Eventos = esNuevo
        ? mapEventosNuevo(item.eventos ?? [])
        : (Array.isArray(item.eventos) ? item.eventos : []);

    const Estado = esNuevo ? (item.horarios ?? []) : [];

    const ultimoEventoTimestamp = esNuevo
        ? (item.eventos?.[item.eventos.length - 1]?.gateESHistoFH ?? null)
        : item.ultimoEventoTimestamp;

    // TODO: reemplazar por id único del back cuando esté disponible (ver TODO línea 1).
    const id = esNuevo
        ? `${item.id}`
        : index + 1;

    return {
        id,
        Estado,
        NombreCompleto,
        DocumentoTipo,
        DocumentoNumero,
        Acceso: item.accesos ?? (item.Acceso ? `Acceso ${item.Acceso}` : ""),
        Horarios: esNuevo
            ? (item.horarios ?? [])
            : (Array.isArray(item.horarios)
                ? item.horarios
                : (item.horarios ? [item.horarios] : [])),
        Eventos,
        ultimoEventoTimestamp,
    };
}